var React = require('react');

function Underline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 2C0 2 11.2753 0 18.5 0C25.7247 0 37 2 37 2V5C37 5 25.7372 4 18.5 4C11.2628 4 0 5 0 5V2Z","fill":"#765C40"}));
}

Underline.defaultProps = {"width":"37","height":"5","viewBox":"0 0 37 5","fill":"none"};

module.exports = Underline;

Underline.default = Underline;
